import styled from 'styled-components';
import { theme } from '../layout/theme';
import React from 'react';

interface ITitle {
  textColor?: string;
  title: string;
}
export const Title = ({ textColor, title }: ITitle) => {
  return (
    <StyledTitle textColor={textColor} title={title}>
      {title}
    </StyledTitle>
  );
};

const StyledTitle = styled.span<ITitle>`
  color: ${(props) => props.textColor};
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 24px;

  ${theme.screens.LtSm} {
    font-size: 1rem;
  }
`;
